<template>
  <div id="enterpriseWrapper">
    <!-- 搜索栏 -->
    <div class="search-box">
      <div>
        <Input v-model="searchValue" prefix="ios-search-outline" placeholder="请输入企业名称"
          style="width: 208px; margin-right: 10px;" @on-enter="handleSearchClick" />
        <Button class="ys-confirm" @click="handleSearchClick">搜索</Button>
      </div>
      <div>
        <Button v-if="hasPerm('org_ent_Add') == 2" class="ys-confirm" icon="ios-add" @click="handleAddClick">新建</Button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table :columns="Columns" :tableData="tableData" :loading="tableLoading" :tableHeight="tableHeight"
      @on-btn-click="onBtnClick">
    </el-table>
    <!-- 分页 -->
    <div class="paging-box">
      <Page :total="totalCount" :current="pageNumber" :page-size="pageSize" @on-change="handlePagingClick" />
    </div>
    <!-- 新增/编辑弹框 -->
    <AddEnterpriseModal :IsOpenModal="IsOpenModal" :operationType="operationType"
      :EnterpriseTypeData="EnterpriseTypeData" :EditEnterpriseInfo="EditEnterpriseInfo" @on-handleClick="handleClick">
    </AddEnterpriseModal>
    <!-- 二次确认框 -->
    <Alter ref="AlterModal" :configData="AlterConfigData" @change_ok="DeleteEnterprise(EditEnterpriseInfo.dept_id)">
    </Alter>
    <!-- 权限弹框 -->
    <jurisdiction-model :popoutType="0" :explainInfo="explainInfo" :MenuPermissionList="MenuPermissionList"
      :currentStatus="currentStatus" @on-jurisdiction-click="onJurisdictionClick"
      @selectedPermissionList="selectedPermissionList">
    </jurisdiction-model>
  </div>
</template>
<script>
  import JurisdictionModel from '_g/commonComponent/jurisdictionModel'; // 权限配置弹框
  import {
    sys_getMenuPermission,
    sys_setMenuPermission
  } from "@/utils/sys_utils/pulicServer" // 获取权限配置数据
  import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
  import ElTable from '_g/commonComponent/table/elTable.vue';
  import Columns from './tableConfig.js'
  import AddEnterpriseModal from "../components/AddEnterpriseModal"
  import {
    mapActions
  } from "vuex"
  export default {
    components: {
      'el-table': ElTable,
      AddEnterpriseModal,
      'jurisdiction-model': JurisdictionModel
    },
    data() {
      return {
        tableData: [], // 数据
        Columns: [], // 表头
        totalCount: 0, // 总条数
        pageNumber: 1, // 当前页码
        pageSize: 12, // 每页显示条数
        tableHeight: 0,
        searchValue: '', // 搜索框的值
        IsOpenModal: false, //是否打开弹框
        operationType: 1, // 操作类型 1新增  2编辑
        EditEnterpriseInfo: {}, //要编辑/删除的企业信息
        AlterConfigData: {}, //二次弹框配置数据
        EnterpriseTypeData: [], //企业类型数据源
        // 权限配置相关变量
        explainInfo: {}, // 权限配置弹框头部基础信息
        MenuPermissionList: [], // 菜单权限数据列表
        currentStatus: false, // 打开权限列表弹框
        tableLoading: true, // 表格loading
      }
    },
    created() {
      this.GetEnterpriseTypeList();
      this.QueryEnterprise(this.pageSize);
    },
    methods: {
      ...mapActions(["DpDeptView_addDpDept", "DpDeptView_qryDpDeptInfoList", "DpDeptView_rmDpDeptInfo",
        "ConfigCodeView_qryConfigByType"
      ]),
      // 获取元素的高度
      getElementHeight() {
        let ERD = elementResizeDetectorMaker();
        let _this = this;
        ERD.listenTo(document.getElementById("enterpriseWrapper"), (element) => {
          _this.tableHeight = (element.scrollHeight - 66 - 90);
        });
      },
      // 操作按钮
      onBtnClick(rowItem, options) {
        switch (options.code) {
          case 0: // 配置权限
            this.explainInfo = rowItem;
            this.getPermissionInfo({
              type_code: 'dpdept', // 部门类型
              org_dept_id: rowItem.dept_id, // 部门ID
            });
            // 每次请求都需要清除原来数据 
            this.MenuPermissionList = [];
            this.currentStatus = true;
            break;
          case 1:
            this.operationType = 2;
            this.EditEnterpriseInfo = Object.assign({}, rowItem);
            this.IsOpenModal = true;
            break;
          case -1:
            this.EditEnterpriseInfo = rowItem;
            this.AlterConfigData = {
              type: "warning",
              title: "警告",
              content: "是否确认删除当前企业信息？"
            }
            this.$refs.AlterModal.OpenModal();
            break;
          default:
            break;
        }
      },
      // 新建功能
      handleAddClick() {
        this.operationType = 1;
        this.IsOpenModal = true;
      },
      // 搜索功能
      handleSearchClick() {
        this.pageNumber = 1;
        this.QueryEnterprise(this.pageSize, 0, this.searchValue);
      },
      // 分页功能
      handlePagingClick(pageNumber) {
        this.pageNumber = pageNumber;
        this.QueryEnterprise(this.pageSize, pageNumber);
      },
      // 弹框操作功能
      handleClick(index, info = null) {
        // 取消
        if (index === 1) {
          this.IsOpenModal = false;
          return;
        } else {
          // 保存
          this.CreateEnterprise(info);
        }
      },
      // 配置权限弹框回调
      onJurisdictionClick(res) {
        this.currentStatus = false;
      },
      //****************** 接口服务 ********************************
      // 新增企业
      CreateEnterprise(enterpriseInfo) {
        this.DpDeptView_addDpDept(enterpriseInfo).then(res => {
          let {
            request_state
          } = res;
          request_state && enterpriseInfo.dept_id ? this.$Message.success("修改企业信息成功！") : this.$Message.success(
            "新增企业成功！");
          this.pageNumber = 1;
          this.IsOpenModal = false; // 关闭弹框
          this.QueryEnterprise(this.pageSize); // 重新查询当前页面数据
        }).catch(err => {
          this.$Message.error("新增企业失败！");
        })
      },
      // 查询企业列表
      QueryEnterprise(pageSize = 0, pageNumber = 0, deptName = null) {
        this.tableLoading = true;
        pageNumber = pageNumber <= 0 ? 0 : pageNumber - 1;
        let params = {
          start_recd: pageNumber * pageSize, // 从第几条开始查询
          limit_recd: pageSize, // 每页显示多少条
          dept_cn_name: deptName == null ? "" : deptName //模糊查询 企业名称
        }
        this.DpDeptView_qryDpDeptInfoList(params).then(res => {
          const {
            request_state,
            dpDeptInfoList,
            all_recd
          } = res;
          if (request_state) {
            this.totalCount = all_recd; // 总条数 
            this.tableData = dpDeptInfoList; // 获取当前分页数据
            this.tableLoading = false;
          }
        }).catch(err => {
          // this.$Message.error(err)
          this.tableLoading = false;
        })
      },
      // 删除企业
      DeleteEnterprise(EnterpriseID) {
        this.DpDeptView_rmDpDeptInfo({
          dept_id: EnterpriseID
        }).then(res => {
          let {
            request_state
          } = res;
          this.pageNumber = 1;
          request_state && this.$Message.success("删除企业成功！");
          this.QueryEnterprise(this.pageSize);
        }).catch(err => {
          this.$Message.error("删除企业失败！")
        })
      },
      // 获取企业类型的数据源
      GetEnterpriseTypeList() {
        this.ConfigCodeView_qryConfigByType({
          type_code: "dpdept"
        }).then(res => {
          let {
            request_state,
            config_list
          } = res;
          if (request_state) {
            this.EnterpriseTypeData = config_list;
          } else {
            this.$Message.error("获取企业类型数据源失败！");
          }
        }).catch(err => {
          this.$Message.error(err);
        })

      },
      // 获取权限数据信息
      getPermissionInfo(params) {
        sys_getMenuPermission(params).then(res => {
          if (res) {
            this.MenuPermissionList = res;
          }
        }).catch(err => {
          this.$Message.error(err);
        })
      },
      // 保存配置的权限数据
      selectedPermissionList(menuList, BtnList) {
        // 如果返回菜单权限
        if (menuList) {
          let params = {
            dept_id: this.explainInfo.dept_id, //当前企业ID
            rs_ary: menuList,
            opt_priv: []
          }
          sys_setMenuPermission(params).then(res => {
            if (res) {
              this.$Message.success("权限配置成功！")
            }
          }).catch(err => {
            this.$Message.error(err);
          })
        }
        if (BtnList) {

        }
      },
      // 处理表头
      disposeColumns() {
        let renderFun = (h, params) => {
          let EnType = params.row.dept_type;
          let EnTypeName = "";
          if (this.EnterpriseTypeData.length > 0) {
            this.EnterpriseTypeData.forEach(item => {
              if (item.con_code == EnType) {
                EnTypeName = item.con_value;
              }
            });
          }
          return h('div', EnTypeName);
        };
        let EnTypeColInfo = Columns.find(item => item.key == "dept_type");
        if (EnTypeColInfo) {
          EnTypeColInfo.render = renderFun;
        }

        this.Columns = Columns;
      }
    },
    mounted() {
      this.disposeColumns();
      // 获取元素高度
      this.getElementHeight();
    },
    // 离开页面处理
    beforeRouteLeave(to, from, next) {
      this.QueryEnterprise(10000); // 新增成功之后  需要重新查询公共使用的企业列表数据
      next()
    }
  }
</script>
<style lang="less" scoped>
  #enterpriseWrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;

    .search-box {
      width: 100%;
      height: 66px;
      padding: 22px 0px 12px 0px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
    }

    .paging-box {
      position: fixed;
      bottom: 0px;
      right: 50px;
      z-index: 1;
      height: 60px;
      width: calc(100% - 250);
      text-align: right;
    }
  }
</style>